export const replaceLinksWithTags = (message: string) => {
  const regex = /https:\/\/\S+/g
  return message.replace(regex, '<a href="$&" style="text-decoration: underline" target="_blank">$&</a>')
}
